module.exports = __webpack_public_path__ + "static/media/instajob-logo.36fb0d1b.png";